import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import style from "./Form.module.scss";

function RegisteredSuccessfully() {
  const navigate = useNavigate();
  const username = localStorage.getItem("userName");
  return (
    <div className={style.registeredBackground}>
      <h1
        style={{ color: "white", fontSize: 40, marginTop: 0, paddingTop: 200 }}
      >
        Felicitări!
      </h1>
      <h1 style={{ color: "white", fontSize: 40, padding: 10 }}>
        Formularul dumneavoastră a fost înregistrat cu succes.
      </h1>
      <Button
        variant="contained"
        size="large"
        className={style.backBtn}
        onClick={() =>
          navigate(username ? "/?isValidated=false?page=1?perPage=10" : "/")
        }
      >
        Înapoi
      </Button>
    </div>
  );
}

export default RegisteredSuccessfully;
